import { render, staticRenderFns } from "./agreementlist.vue?vue&type=template&id=255dae99&scoped=true&"
import script from "./agreementlist.vue?vue&type=script&lang=js&"
export * from "./agreementlist.vue?vue&type=script&lang=js&"
import style0 from "./agreementlist.vue?vue&type=style&index=0&id=255dae99&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255dae99",
  null
  
)

export default component.exports